// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3XQBi","title":"ClientReferral_title__1zmky","itemText":"ClientReferral_itemText__3cCcm"};